<template>
  <div class="card"><slot></slot></div>
</template>

<script>
export default {
  name: 'MCard'
}
</script>

<style scoped>
.card {
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 5%);
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
  width: 100%;
  padding-bottom: 1rem;
}
</style>
